
import Vue from 'vue'
import { VBreadcrumbs } from 'vuetify/lib'
import { breadcrumb } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcBreadcrumbs',
  components: {
    VBreadcrumbs,
  },
  props: {
    items: {
      type: Array as () => Array<breadcrumb>,
      required: true,
    },
  },
})
